"use client";

import { useSession } from "next-auth/react";
import React, { useEffect } from "react";
import Link from "next/link";
import Loading from "@/components/Common/Loading";
import Sal from "sal.js";

import RoadmapData from "../../data/roadmap.json";

const Roadmap = () => {
  const { data: status } = useSession();

  useEffect(() => {
    Sal();
  }, []);

  useEffect(() => {
    if (status !== "loading") {
      Sal();
    }
  }, [status]);

  if (status === "loading") {
    return <Loading />;
  }

  return (
    <>
      <div className="roadmap-section rainbow-section-gap rainbow-section-gapBottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="section-title text-center"
                data-sal="slide-up"
                data-sal-duration="400"
                data-sal-delay="150"
              >
                <h2 className="subtitle">
                  <span className="theme-gradient">Lo próximo en TutorIA+</span>
                </h2>
                <p className="description b1">
                  Estamos mejorando la forma en que creas tus clases para que
                  todo sea más rápido, simple y útil en tu día a día.
                </p>
              </div>
            </div>
          </div>

          {RoadmapData &&
            RoadmapData.roadmap.map((data, index) => (
              <div className="row changelog_info" key={index}>
                <div className="col-lg-3 changelog_date">
                  <div className="c_date">
                    <h6>{data.heading}</h6>
                    <p>{data.date}</p>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="version_info">
                    {data.isCompleted ? (
                      <div className="c_version">
                        <i className="fa-solid fa-check"></i>
                      </div>
                    ) : (
                      <div className="c_version bg-comming">
                        <i className="fa-solid fa-clock"></i>
                      </div>
                    )}

                    {data.isBorder ? (
                      <div className="line bottom_half"></div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="changelog_content">
                    <p className="text">{data.desc}</p>
                    {data.title && <p className="title">{data.title}</p>}
                    {data.list && (
                      <ul className="content-list">
                        {data.list.map((item, i) => (
                          <li key={i}>{item.desc}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className="rainbow-callto-action rainbow-call-to-action style-8 content-wrapper rainbow-section-gapBottom">
        <div className="container">
          <div className="row row--0 align-items-center ">
            <div className="col-lg-12">
              <div className="inner">
                <div className="content text-center">
                  <h3
                    className="title sal-animate"
                    data-sal="slide-up"
                    data-sal-duration="400"
                    data-sal-delay="200"
                  >
                    ¿Qué te ayudaría a preparar mejor tus clases?
                  </h3>
                  <p
                    className="sal-animate"
                    data-sal="slide-up"
                    data-sal-duration="400"
                    data-sal-delay="300"
                  >
                    Cuéntanos qué te gustaría crear o mejorar para que tu clase
                    esté lista más rápido.
                  </p>
                  <div
                    className="call-to-btn text-center mt--30 sal-animate"
                    data-sal="slide-up"
                    data-sal-duration="400"
                    data-sal-delay="400"
                  >
                    <Link className="btn-default btn-icon" href="/contacto">
                      Enviar sugerencia
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Roadmap;
